import React from 'react';
import { Button } from 'kenshin';
import {
  CloseOutlined,
  DownloadOutlined,
  CopyOutlined,
  StarOutlined,
  EditOutlined,
  ExpandOutlined,
  EraserOutlined,
  PictureOutlined,
  VideoCameraOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import './index.less';

const ImagePreview = ({ imageUrl, onClose }) => {
  const actionButtons = [
    { label: '添加到对话', icon: <PictureOutlined />, action: () => {} },
    { label: '生成视频', icon: <VideoCameraOutlined />, action: () => {} },
    { label: '超清', icon: <ExpandOutlined />, action: () => {} },
    { label: 'AI改图', icon: <EditOutlined />, action: () => {} },
    { label: '扩图', icon: <ExpandOutlined />, action: () => {} },
    { label: '消除', icon: <EraserOutlined />, action: () => {} },
    { label: '下载', icon: <DownloadOutlined />, action: () => {} },
    { label: '重新生成', icon: <RedoOutlined />, action: () => {} },
  ];

  return (
    <div className="imagePreviewOverlay" onClick={onClose}>
      <div className="imagePreviewContent" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <div className="closeBtn" onClick={onClose}>
          <CloseOutlined />
        </div>

        {/* 返回按钮 */}
        <Button className="backBtn" onClick={onClose}>
          返回对话
        </Button>

        {/* 主图 */}
        <div className="mainImage">
          <img src={imageUrl} alt="预览图片" />
        </div>

        {/* 右侧操作区 */}
        <div className="sidePanel">
          {/* 缩略图列表 */}
          <div className="thumbList">
            <img src={imageUrl} alt="" className="thumbItem" />
            <img src={imageUrl} alt="" className="thumbItem" />
            <img src={imageUrl} alt="" className="thumbItem" />
            <img src={imageUrl} alt="" className="thumbItem" />
          </div>

          {/* 操作按钮 */}
          <div className="actionButtons">
            {actionButtons.map((btn, idx) => (
              <Button
                key={idx}
                className="actionBtn"
                onClick={btn.action}
              >
                {btn.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagePreview;
